/* eslint-disable no-undef */
import React, { useContext } from 'react';

import LocaleContext from 'constants/localization';
import LocalizedStrings from 'react-localization';
import API from 'constants/api';
import Form from 'react-bootstrap/Form';
import Header from 'field/common/Header';
import AutoSuggest from 'field/edit/resource/AutoSuggest';

const OCMEdit = ({ field }) => {
  const LS = useContext(LocaleContext);
  strings.setLanguage(LS.getLanguage());

  const getClassifications = (key, value) => {
    return fetch(`${API.OCM}?key=${key}&value=${value}`)
      .then(res => res.json())
      .catch(e => console.log(e));
  };

  const suggestMargin = { margin: '0.25rem 0' };

  return (
    <Form.Group className="field" >
      <Header field={field} />
      <AutoSuggest
        placeholder={strings.searchByNumber}
        getSuggestions={(key) => getClassifications(key, '')}
        onSelect={o => field.addValue(o.display)}
        style={suggestMargin}
        minLength={2}
      />
      <AutoSuggest
        placeholder={strings.searchByName}
        getSuggestions={(value) => getClassifications('', value)}
        onSelect={o => field.addValue(o.display)}
        style={suggestMargin}
      />
      <div>
        {
          field.values.map((value, index) => (
            <div className="value" key={index}>
              <label>{value}</label>
              <input type="checkbox"
                checked={true} 
                onChange={() => field.removeValue(index)} />
            </div>
          ))
        }
      </div>
    </Form.Group>
  );
};

const strings = new LocalizedStrings({
  fi: {
    searchByName: 'hae nimellä',
    searchByNumber: 'hae numerolla',
  },
  en: {
    searchByName: 'search by name',
    searchByNumber: 'search by number',
  }
});

export default OCMEdit;